










import { defineComponent, computed } from '@vue/composition-api';

/**
 * Reusable eyecatcher component.
 */
export default defineComponent({
	props: {
		/**
		 * Display a secondary colored eyecatcher instead of a primary colored one.
		 */
		secondary: Boolean,
		/**
		 * Show a round eyecatcher instead of an angular shaped one. Text within a round
		 * eyecatcher must be wrapped in a `span`, if it should appear largely, you
		 * have to set the class `olb-eyecatcher-round-large` on the respective `span`.
		 */
		round: Boolean,
		/**
		 * Do not rotate the eyecatcher, in case an image is displayed inside of it.
		 */
		img: Boolean,
	},
	setup(props) {
		const classes = computed(() => [
			'olb-eyecatcher',
			props.secondary && 'olb-eyecatcher-secondary',
			props.round && 'olb-eyecatcher-round',
			props.img && 'olb-eyecatcher-img',
		]);

		return { classes };
	},
});
